// extracted by mini-css-extract-plugin
export default {"header":"Header_header__BKh8b","header__wrapper":"Header_header__wrapper__dkCen","header__arrow":"Header_header__arrow__fRNWR","header__link":"Header_header__link__Raiaf"};